const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
function isIsoCalendarDate(value) {
    const match = ISO_DATE_PATTERN.exec(value);
    if (!match) {
        return false;
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const daysByMonth = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return month >= 1 && month <= 12 && day >= 1 && day <= daysByMonth[month - 1];
}
function isWhatsNewRelease(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'version' in value &&
        typeof value.version === 'string' &&
        /^\d+\.\d+\.\d+$/.test(value.version) &&
        'date' in value &&
        typeof value.date === 'string' &&
        isIsoCalendarDate(value.date) &&
        'summary' in value &&
        Array.isArray(value.summary) &&
        value.summary.length > 0 &&
        value.summary.every((item) => typeof item === 'string' && item.length > 0));
}
export function formatWhatsNewDate(isoDate) {
    const match = ISO_DATE_PATTERN.exec(isoDate);
    if (!match || !isIsoCalendarDate(isoDate)) {
        throw new TypeError('Invalid whats-new release date');
    }
    const [, year, month, day] = match;
    return `${day}/${month}/${year.slice(-2)}`;
}
export function parseWhatsNewHistory(value) {
    if (typeof value !== 'object' ||
        value === null ||
        !('releases' in value) ||
        !Array.isArray(value.releases) ||
        value.releases.length === 0 ||
        !value.releases.every(isWhatsNewRelease) ||
        value.releases.some((release, index, releases) => index > 0 && releases[index - 1].date < release.date)) {
        throw new TypeError('Invalid whats-new release history');
    }
    return value;
}
